import {SimplePageHeader} from '@flexinet/ui-components';

export const ProfilePageHeader = () => {
    return (
        <SimplePageHeader
            title="Account & Billing"
            tools={[]}
        />
    );
};
